import {useEffect, useState} from "react";
import {HiMenuAlt4, HiX} from "react-icons/hi";
import {motion} from "framer-motion";

import {images} from "../../constants";
import "./Navbar.scss";

const navItems = ["home", "about", "work", "skills", "contact"];

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    if (!toggle) {
      document.body.style.overflow = "";
      return undefined;
    }

    document.body.style.overflow = "hidden";

    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setToggle(false);
      }
    };

    window.addEventListener("keydown", handleEsc);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [toggle]);

  return (
    <nav className="app__navbar" aria-label="Main navigation">
      <div className="app__navbar-logo">
        <img src={images.logo} alt="logo" />
      </div>
      <ul className="app__navbar-links">
        {navItems.map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>

      <div className="app__navbar-menu">
        <button
          type="button"
          className="app__navbar-menu-btn"
          aria-label="Open menu"
          aria-expanded={toggle}
          aria-controls="mobile-nav-menu"
          onClick={() => setToggle(true)}
        >
          <HiMenuAlt4 />
        </button>

        {toggle && (
          <motion.div
            id="mobile-nav-menu"
            initial={{x: 300}}
            animate={{x: 0}}
            transition={{duration: 0.85, ease: "easeOut"}}
          >
            <button
              type="button"
              className="app__navbar-close-btn"
              aria-label="Close menu"
              onClick={() => setToggle(false)}
            >
              <HiX />
            </button>
            <ul>
              {navItems.map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
